import styled from 'styled-components'

export const HeaderRow = styled.div`
  background-color: var(--tds-white);
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`
